import { useMutation } from '@tanstack/react-query';
import { patchProcessedTimesheetStatus } from '../Services/ProcessedTimesheetService';

const usePatchProcessedTimesheetStatus = (options = {}) =>
    useMutation(patchProcessedTimesheetStatus, options);

export default usePatchProcessedTimesheetStatus;
